import PropTypes from 'prop-types';
import { LightBoxWrapper } from './LightBoxWrapper.js';


// Wrapper for the animated SVGs that show a heart dropping into a shopping cart.
//
// We use inline SVGs in this component, which isn't ideal.
//
// We have cleaner SVG tooling available, but only to code that's compiled using Rollup; see rollup.config.js.
// This file is used on the project page, so we can't switch over to those tools here yet. Once the project page is on
// Rollup, we can probably replace this with a standalone .svg file.
let AnimationWrapper = () => {
    return (
        <div className="cart-animation-wrapper">
            <svg id="heart" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94.81 81.72">
                <path className="heart"
                      style={{fill: '#ffc910'}}
                      d="m47.26,81.72L5.15,38.85C1.93,34.76,0,29.58,0,23.94,0,10.72,10.6,0,23.68,0s23.02,10.15,23.58,22.88h0C47.81,10.15,58.4,0,71.12,0c13.08,0,23.68,10.72,23.68,23.94,0,5.63-1.93,10.81-5.15,14.9l-42.4,42.87Z"/>
            </svg>
            <svg id="cart" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 148.68 140.77">
                <path className="cls-2"
                      style={{fill: '#ffc90e'}}
                      d="m59.01,111.89c-4.02,1.14-7.16,3.44-9.26,7.08-1.8.52-3.42-.24-4.97-.87-4.48-1.83-7.85-4.96-9.21-9.62-1.5-5.15-.49-9.9,3.35-13.97,2.1-2.23,4.6-3.56,7.45-4.43.39,1.4.71,2.82,1.18,4.19.51,1.51,1.54,2.5,3.23,2.6-1.69.3-3.36.61-4.85,1.61-3.91,2.66-4.39,7.2-1.44,10.45,1.54,1.69,3.61,2.69,6,2.72,2.63.04,5.27.02,7.9.04.22,0,.49-.08.64.19Z"/>
                <g className="basket">
                    <path className="cls-2"
                          style={{fill: '#ffc90e'}}
                          d="m35.97,23.7c-3.25,1.88-5.03,4.69-5.3,8.44-.8-.07-.53-.83-.64-1.21-1.48-5.04-2.88-10.1-4.28-15.16-.63-2.29-1.23-4.59-1.83-6.88-.22-.84-.57-1.3-1.61-1.28-6.07.08-12.15.09-18.23.1-3.06,0-4.83-2.45-3.79-5.28C.76,1.17,1.64.29,3.07.18c.91-.07,1.83-.14,2.75-.14C12.22.02,18.61,0,25.01,0c3.8,0,4.79.88,5.69,4.58.79,3.27,1.79,6.49,2.68,9.74.8,2.94,1.58,5.9,2.37,8.84.05.19.15.36.23.53Z"/>
                    <path className="cls-1"
                          style={{fill: '#51a5db'}}
                          d="m46.36,90.08c-1.25-4.52-2.49-9.04-3.76-13.55-1.61-5.74-3.16-11.49-4.85-17.21-1.43-4.85-2.64-9.77-3.99-14.64-.83-3.01-1.76-5.99-2.61-8.99-.33-1.15-.62-2.33-.49-3.55-.25-.31-.25-.67-.19-1.03.47-3.02,1.97-5.41,4.49-7.15.3-.2.62-.37,1-.26,2.34-1.06,4.82-1.12,7.33-1.12,33.83.02,67.66.01,101.49.01,3.05,0,4.28,1.54,3.79,4.58-.3,1.85-.94,3.6-1.42,5.4-1.38,5.21-2.86,10.39-4.27,15.59-1.26,4.67-2.46,9.36-3.71,14.03-1.37,5.16-2.76,10.32-4.15,15.47-1.35,5-2.7,10-4.07,15-.2.72-.4,1.46-.74,2.11-.65,1.25-1.59,2.07-3.17,2.07-24.87-.02-49.75-.01-74.62-.01-.56,0-1.12.03-1.68.04-1.24.21-2.25-.27-2.85-1.28-.99-1.68-1.58-3.52-1.56-5.51Z"/>
                    <path className="cls-3"
                          style={{fill: '#241d5d'}}
                          d="m90.95,60.88c-4,0-8,.03-12-.02-.86-.01-1.05.25-1.02,1.07.31,8.33.56,16.67.86,25,.06,1.75-.18,3.3-1.92,4.14-2.01.97-4.84-.12-4.93-2.64-.25-7.54-.54-15.07-.81-22.6-.05-1.28-.15-2.55-.11-3.83.02-.88-.24-1.14-1.15-1.14-7.72.04-15.44.02-23.16.02-1.65,0-2.98-1.04-3.53-2.53-.87-2.37,1.53-4.73,3.6-4.68,3.96.09,7.92.02,11.88.02,3.6,0,7.2-.03,10.8.02.95.01,1.27-.13,1.22-1.22-.29-6.42-.47-12.84-.69-19.26-.04-1.27-.17-2.55-.16-3.82.01-1.4,1.03-2.63,2.41-3.12,1.16-.41,2.73.02,3.62.98.72.79.84,1.79.88,2.76.29,7.37.55,14.75.75,22.13.03,1.2.35,1.58,1.62,1.57,8.04-.07,16.08-.04,24.12-.02.86,0,1.23-.11,1.25-1.14.18-6.74.45-13.48.69-20.21.03-.92.11-1.83.15-2.75.09-2.1,1.62-3.61,3.59-3.45,2.02.16,3.4,2.2,3.34,3.81-.27,7.06-.52,14.11-.77,21.17-.09,2.55-.08,2.55,2.53,2.55,5.72,0,11.44,0,17.16,0,.79,0,1.57.04,2.35.23,1.96.48,2.66,1.95,2.54,3.8-.12,1.79-1.66,3.16-3.39,3.16-6.8,0-13.6.02-20.4-.02-.89,0-1.19.16-1.22,1.15-.22,7.82-.49,15.63-.8,23.44-.05,1.13-.02,2.28-.33,3.42-.38,1.39-1.58,2.46-3.14,2.5-1.96.06-2.68-.64-3.28-2.33-.48-1.33-.15-2.56-.11-3.83.18-6.3.39-12.6.59-18.9.05-1.44.07-2.87.18-4.3.07-.87-.15-1.16-1.09-1.15-4.04.06-8.08.02-12.12.02Z"/>
                </g>
                <path className="cls-1"
                      style={{fill: '#51a5db'}}
                      d="m108.92,111.9c3.42-.73,6.71-.6,9.97.92,5.46,2.54,9,8.28,8.49,14.61-.48,5.9-5.03,11.26-10.84,12.79-6.15,1.62-12.09-.65-15.7-5.52-2.97-3.99-3.57-8.54-2-13.31.22-.68.48-1.35.72-2.02-.03-1.12.83-1.77,1.43-2.52,1.95-2.45,4.34-4.28,7.47-4.99.16-.04.31-.05.46.03Z"/>
                <path className="cls-1"
                      style={{fill: '#51a5db'}}
                      d="m75.84,119.33c2.28,4.89,2.26,9.74-.6,14.37-3.56,5.77-9.85,8.13-16.03,6.62-5.81-1.42-9.59-5.38-10.85-11.26-.64-2.98-.5-6.12,1-8.98.18-.34.45-.67.37-1.11.23-1.43,1.22-2.4,2.17-3.32,1.98-1.93,4.19-3.53,7.1-3.76,2.17-.57,4.36-.67,6.55-.16.25.06.45.03.67-.01,4.09.76,6.97,3.22,9.24,6.54.22.32.5.63.38,1.08Z"/>
                <path className="cls-2"
                      style={{fill: '#ffc90e'}}
                      d="m75.84,119.33c-1.52-2.57-3.53-4.65-6.11-6.15-.77-.44-1.64-.72-2.49-.99-.37-.11-.73-.19-1.01-.48,14.02,0,28.05-.02,42.07-.02.22,0,.49-.08.63.2-3.92,1.03-6.75,3.51-9.01,6.76-.16.23-.03.57-.35.71-7.91-.01-15.82-.03-23.73-.04Z"/>
            </svg>
        </div>
    );
}

let SearchLink = ({searchUrl, onClose}) => {
    let href, onClick;
    if (searchUrl) {
        href = searchUrl;
        // Defer to default link-click-behavior
        onClick = undefined;
    } else {
        href = '#';
        onClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            onClose();
        }
    }

    return (
        <a className="button-secondary full-width" href={href} onClick={onClick}>Support another classroom</a>
    );
}

export let AddedToCart = ({ amount, onClose, searchUrl }) => {
    return (
        <LightBoxWrapper unMountHandler={onClose}>
            <div className="cart-container show">
                <div className="cart-modal">
                    <div className="modal-container">
                        <AnimationWrapper />
                        <h3>Your ${amount} donation was added to your cart!</h3>
                        <div className="inline-button">
                            <a target="_top" className="button-primary full-width" href={`${secureBaseURL}donors/givingCart.html`}>Check out now</a>
                            <SearchLink searchUrl={searchUrl} onClose={onClose} />
                        </div>
                    </div>
                </div>
            </div>
        </LightBoxWrapper>
    )
}
AddedToCart.propTypes = {
    amount: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
    // If not provided, the search-link will just close the overlay. Do this if, say, you're already on a search page.
    searchUrl: PropTypes.string,
}
